import { Chip } from "@mui/material"

export function TaskReadOnlyComplianceChip({ item }) {
    return <Chip size="small" variant="outlined" label={item.code ? `${item.code} - ${item.title}` : item.title} />
}
